import type { ActionPanel as ActionPanelProps } from '../../../../../types/cancellation/action-panel';

import * as styles from './index.css';
import ActionCard from '../../cards/action';
import { EventScopeProvider } from '@blueshift-ui/analytics';
import { StructuredText } from 'react-datocms/structured-text';
import SubscriptionCard from '../../cards/subscription';
import Typography from '@blueshift-ui/theme/dist/components/typography';
import getDowngradeOptions from '../../../../../helpers/data/get-downgrade-options';

function ActionPanel({
  actionCards,
  hasDowngradeOptions,
  subscription,
  title,
  ...props
}: ActionPanelProps) {
  if (!subscription) {
    return null;
  }

  return (
    <>
      <Typography className={styles.heading} component="div">
        <StructuredText data={title} />
      </Typography>
      {hasDowngradeOptions ? (
        <EventScopeProvider eventScope={{ pageSection: 'cancel_membership_downgrade_options' }}>
          {getDowngradeOptions(subscription)?.map((option, index) => (
            <SubscriptionCard
              currentSubscription={subscription}
              key={index}
              newSubscription={option}
            />
          ))}
        </EventScopeProvider>
      ) : (
        <EventScopeProvider eventScope={{ pageSection: 'cancel_membership_action_cards' }}>
          {actionCards.map((actionCard, index) => (
            <ActionCard key={index} subscription={subscription} {...actionCard} />
          ))}
        </EventScopeProvider>
      )}
    </>
  );
}

export default ActionPanel;
